import { DataStore } from "@aws-amplify/datastore";
import { AssetAttribute } from "models";

export function deleteAssetAttribute(assetAttributeId) {
  return DataStore.delete(AssetAttribute, assetAttributeId);
}